import { render, staticRenderFns } from "./hqglLogisticsItemSaleInfo.vue?vue&type=template&id=612b687c&scoped=true&"
import script from "./hqglLogisticsItemSaleInfo.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsItemSaleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b687c",
  null
  
)

export default component.exports